<template>
  <img
    src="/logo.svg"
    alt="Logo"
    height="40"
    width="40"
  />
</template>

<script>
export default {
  name: 'ProjectLogo'
}
</script>
